import {
  FormControlLabel,
  Typography,
  Checkbox as MuiCheckbox,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Controller } from "react-hook-form";
import Checkbox from "../../../../common/FormComponents/CheckBox";
import Input from "../../../../common/FormComponents/Input";
import Select from "../../../../common/FormComponents/Select";
import { monthLocales } from "../../../../../constant/monthLocales";
import { getSelectedCountry } from "../../../../../utils/common";
import { CountryLabel } from "../../../../../types/common";
import { useEffect } from "react";

//TODO: we should define a proper type for the props instead of using 'any' - this is added to have possibility to define new props using strong typing
type PassportProps = {
  age: number | null;
} & Record<string, any>;

const Passport = ({
  control,
  errors,
  pageText,
  DayList,
  getLanguageCode,
  passportExpiryOptional,
  showConsents,
  setValue,
  watch,
  age,
}: PassportProps) => {
  const getPassportYearList = () => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 0;
    const endYear = currentYear + 20;
    return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
      const year = startYear + i;
      return { label: year.toString(), value: year };
    });
  };

  const country = getSelectedCountry();
  const passportYearsList = getPassportYearList();
  const languageCode = getLanguageCode();
  const [skipPassportExpiry, passportNo] = watch([
    "skipPassportExpiry",
    "PassportNo",
  ]);

  const passportNumberRequired =
    country?.label !== CountryLabel.Myanmar || !age || age >= 18;
  const hidePassportExpiry = !passportNumberRequired && !passportNo;

  useEffect(() => {
    if (!passportNo && !passportNumberRequired) {
      setValue("passportEx", {
        day: "",
        month: "",
        year: "",
      });
      setValue("skipPassportExpiry", false);
    }
  }, [passportNo, passportNumberRequired, setValue]);

  return (
    <>
      <Grid xs={12} sm={6} className="field">
        <Input
          name="PassportNo"
          type="text"
          control={control}
          placeholder={pageText?.validationMessages?.pleaseEnterPassportNumber}
          maxLength={12}
          errors={errors}
          label={`${pageText?.labelsMetadata?.passportNoLabel}${
            passportNumberRequired ? " *" : ""
          }`}
          rules={{
            validate: (value) => {
              if (passportNumberRequired && !value) {
                return pageText?.validationMessages?.pleaseEnterPassportNumber;
              }
              return true;
            },
          }}
        />
      </Grid>
      {!hidePassportExpiry && (
        <>
          <Grid
            xs={12}
            className="field"
            component={Typography}
            fontSize="14px"
          >
            {pageText?.labelsMetadata.passportExpiryLabel}
            {passportExpiryOptional && (
              <Controller
                render={({ field }) => (
                  <FormControlLabel
                    sx={{ ml: 2 }}
                    control={
                      <MuiCheckbox
                        size="small"
                        value={field.value || ""}
                        onChange={(event, checked) => {
                          if (checked) {
                            setValue("passportEx", {
                              day: "",
                              month: "",
                              year: "",
                            });
                          }
                          field.onChange(event, checked);
                        }}
                        checked={!!field.value}
                      />
                    }
                    label={
                      <Typography fontSize="12px">
                        {pageText?.labelsMetadata?.leaveifblank}
                      </Typography>
                    }
                  />
                )}
                name="skipPassportExpiry"
                control={control}
              />
            )}
          </Grid>
          {!skipPassportExpiry && (
            <>
              <Grid xs={12} sm={4} className="field">
                <Select
                  label={`${pageText?.labelsMetadata?.day} *`}
                  classNamePrefix={"form_drop"}
                  placeholder={`${pageText?.labelsMetadata?.selectText}`}
                  options={DayList}
                  control={control}
                  errors={errors}
                  name="passportEx.day"
                  rules={{
                    required: {
                      value: true,
                      message: pageText?.textMetadata?.pleaseselectday,
                    },
                  }}
                />
              </Grid>
              <Grid xs={12} sm={4} className="field">
                <Select
                  label={`${pageText?.labelsMetadata?.month} *`}
                  classNamePrefix={"form_drop"}
                  placeholder={`${pageText?.labelsMetadata?.selectText}`}
                  options={
                    languageCode.substring(0, 2) === "en"
                      ? monthLocales["en-GB"]
                      : monthLocales[languageCode]
                  }
                  control={control}
                  errors={errors}
                  name="passportEx.month"
                  rules={{
                    required: {
                      value: true,
                      message: pageText?.textMetadata?.pleaseselectmonth,
                    },
                  }}
                />
              </Grid>
              <Grid xs={12} sm={4} className="field">
                <Select
                  label={`${pageText?.labelsMetadata.year} *`}
                  classNamePrefix={"form_drop"}
                  placeholder={`${pageText?.labelsMetadata?.selectText}`}
                  options={passportYearsList}
                  control={control}
                  errors={errors}
                  name="passportEx.year"
                  rules={{
                    required: {
                      value: true,
                      message: pageText?.textMetadata?.pleaseselectyear,
                    },
                  }}
                />
              </Grid>
            </>
          )}
        </>
      )}
      {showConsents && (
        <>
          <Grid xs={12} className="field">
            <Checkbox
              control={control}
              name="VoiceConsent"
              errors={errors}
              label={`${pageText?.labelsMetadata?.voiceConsentLabel} *`}
              rules={{
                required: {
                  value: true,
                  message:
                    pageText?.validationMessages?.pleaseAcceptVoiceConsent,
                },
              }}
            />
          </Grid>
          <Grid xs={12} className="field">
            <Checkbox
              control={control}
              name="UkbaConsent"
              errors={errors}
              label={`${pageText?.labelsMetadata?.ukbaConsentLabel} *`}
              rules={{
                required: {
                  value: true,
                  message:
                    pageText?.validationMessages?.pleaseAcceptUkbaConsent,
                },
              }}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default Passport;
